import styled from 'styled-components';

export const UserProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  min-height: calc(100vh - 41px); /* Adjust if Navbar height is different */
  color: #B6C2CF; /* Default text color for dark theme */
  /* background-color removed, will be set by inline style */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; /* Ensures background is fixed during scroll */
  margin-top: 41px; /* Assuming Navbar height is 41px */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */

  /* Adjust text colors for better readability on potentially varied backgrounds */
  & p { /* Target potential error messages or other text */
    color: #FFFFFF; /* White text for high contrast on dark/image backgrounds */
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent dark background for text */
    padding: 8px 12px;
    border-radius: 4px;
  }
`;

export const Avatar = styled.img`
  width: 128px;
  height: 128px;
  border-radius: 50%;
  margin-bottom: 24px;
  border: 4px solid white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const UserInfo = styled.div`
  text-align: center;
`;

export const UserName = styled.h1`
  font-size: 28px; /* Slightly larger for better visibility */
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #FFFFFF; /* White text for high contrast */
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.7); /* Text shadow for readability */
`;

export const UserEmail = styled.p`
  font-size: 18px; /* Slightly larger */
  color: #E0E0E0; /* Light gray for email, still good contrast */
  margin: 0;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.7); /* Text shadow for readability */
`;

// Add more styled components if needed for other user details
// For example, a section for projects or activity
/*
export const SectionTitle = styled.h2`
  font-size: 20px;
  color: #172b4d;
  margin-top: 32px;
  margin-bottom: 16px;
  border-bottom: 1px solid #dfe1e6;
  padding-bottom: 8px;
`;
*/
